import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './themes/userThemes.css';
import App from './App';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<React.StrictMode><App /></React.StrictMode>);

// Register service worker early — required for push notifications to work
// No permission needed here, just registers the SW file
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js', { scope: '/' })
      .then(reg => {
        console.log('[SW] Registered scope:', reg.scope);
      })
      .catch(err => {
        // Non-fatal — push notifications just won't work
        console.warn('[SW] Registration failed:', err.message);
      });
  });
}
